import { Component } from 'react';
import Checkbox from '../../Checkbox';
import Text from '../../Text';
import styles from './MenuItem.module.scss';

export type MenuItemProps = {
    isSelected?: boolean;
    onClick?: () => void;
    rightIcon?: Component;
    children?: React.ReactNode;
    checkable?: boolean;
    isChecked?: boolean;
    "data-testid"?: string;
};

export const MenuItem = ({
    onClick,
    rightIcon: RightIcon,
    children,
    checkable = false,
    isChecked = false,
    "data-testid": dataTestId,
}: MenuItemProps) => (
    <div
        className={styles.item}
        onClick={onClick}
        data-testid={dataTestId}
    >
        {checkable && (
            <Checkbox
                onClick={onClick}
                checked={isChecked}
                onChange={() => {}}
            />
        )}
        <div className={styles.menuItemContainer}>
            <Text variant="body">{children}</Text>
        </div>
    </div>
);
